import { useMemo, useRef } from "react";
import classes from "classnames";
import styles from "./index.module.scss";

export interface ImageProps {
  src: string;
  width: number;
}
const Image = ({ src, width }: ImageProps) => {
  const container = useRef<HTMLDivElement>(null!);
  const imageWidth = useMemo(() => {
    if (!width) {
      return "auto";
    }
    if (!container.current) {
      return "100%";
    }
    if (width > container.current.clientWidth) {
      return "100%";
    }
    return width;
  }, [width]);

  return (
    <div className={classes("container", styles.image)} ref={container}>
      <img
        src={src}
        style={{ width: imageWidth }}
        alt=""
        crossOrigin="anonymous"
      />
    </div>
  );
};

export default Image;
